import React, { useEffect, useState } from 'react';
import { getInfoAluno } from '../../Api';
import { useNavigate, useParams } from 'react-router-dom';

export default function Validacao() {
    const { email } = useParams();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {

        if (!email) return  navigate("/");
        

        getInfoAluno({ email })
            .then(res => {
                if (res.data && res.data.cpf && res.data.codigoUso) {
                    // Monta a URL de destino
                    const redirectSite = `https://www.uebcarteirinha.com.br/validador/${res.data.cpf}/${res.data.codigoUso}`;
                    
                    // Executa o redirecionamento externo
                    window.location.href = redirectSite;
                } else {
                    navigate("/")
                    console.error("Dados insuficientes para redirecionamento", res.data);
                    setLoading(false);
                }
            })
            .catch(err => {
                console.error("Erro ao buscar info do aluno:", err);
                setLoading(false);
            });
    }, [email]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif' }}>
            {loading ? (
                <div style={{ textAlign: 'center' }}>
                    <p>Validando credenciais...</p>
                    {/* Você pode colocar um Spinner/CircularProgress aqui */}
                </div>
            ) : (
                <p>Erro ao validar estudante ou dados não encontrados.</p>
            )}
        </div>
    );
}